<template>
  <div class="test_big">
    <img class="imgbox" src="../../../static/img2/loginbj.png" alt="" />
    <div class="login">
      <img class="imgboxdsd" src="../../../static/img2/linongdsd.png" alt="" />
      <img src="../../../static/img2/lgonn.png" class="gk" alt />
      <div class="iframe" v-show="cerebrum">
        <iframe
          title="恒牙列三维模型"
          loading="eager"
          src="./static/dental-viewer/index.html"
          allowfullscreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          oallowfullscreen="true"
          msallowfullscreen="true"
        ></iframe>
      </div>
      <div class="login-body">
        <div class="login-form">
          <div class="loginbox" v-show="tab == 1">
            <div class="tt">
              <span
                @click="tabChange1"
                data-id="1"
                :style="{ color: activeColor1 }"
                v-show="modexeiyi"
                style="cursor:pointer;font-size: .18rem;"
                >账号登录</span
              ><img src="../../../static/img2/shux.png" alt="" /><span
                v-show="modexeiyi"
                @click="tabChange2"
                data-id="2"
                :style="{ color: activeColor2 }"
                style="cursor:pointer;font-size: .18rem;"
                >扫码登录</span
              >
            </div>
            <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2">
              <el-tabs v-model="activeName">
                <!-- <el-tab-pane label="账号密码登录" name="username"> -->
                <img
                  src="../../../static/img2/usericon.png"
                  alt=""
                  style="position: absolute;top: .38rem;left: .24rem;width: .14rem;height: .14rem;z-index: 1000;"
                />
                <el-form-item prop="username" class="form-group">
                  <img
                    src="../../../static/img2/shux.png"
                    style="width:.02rem ;height:.15rem ;padding-left: .6rem;padding-top:.38rem;z-index:1000"
                    alt=""
                  />
                  <input
                    v-model="ruleForm2.username"
                    placeholder="请输入登录名"
                    @keyup.enter="submitForm('ruleForm2')"
                    style="padding-left: .8rem; background-color: rgba(13, 41, 50, 0.8); border: 0; border-radius: .15rem;
                          position: absolute;
                          top: .2rem;
                          left: 0;
                          "
                  />
                </el-form-item>
                <el-form-item prop="password" class="form-group">
                  <img
                    src="../../../static/img2/passwordicon.png"
                    class="passwordicon"
                    style="position: absolute;top: .44rem;left: .24rem;width: .14rem;height: .14rem;z-index: 1000;"
                    alt=""
                  />
                  <img
                    src="../../../static/img2/shux.png"
                    style="width:.02rem ;height:.15rem ;padding-left: .6rem;padding-top:.44rem;z-index:1000"
                    alt=""
                  />
                  <img
                    :src="paSrc"
                    style="width:.17rem ;height:.08rem; position:absolute;top:.48rem;right:.2rem;z-index: 10000;"
                    alt=""
                    @click="changePassward"
                  />
                  <input
                    v-model="ruleForm2.password"
                    placeholder="请输入密码"
                    :type="passwordType"
                    @keyup.enter="submitForm('ruleForm2')"
                    v-on:keyup.20="test"
                    style="padding-left:.8rem;background-color: rgba(13, 41, 50, 0.8); border: 0; border-radius: .15rem;
                          position: absolute;
                          top: .26rem;
                          left: 0;
                          "
                  />
                </el-form-item>

                <el-form-item class="form-group" prop="verification">
                  <input
                    v-model="ruleForm2.verification"
                    placeholder="请输入验证码"
                    style="width: 50%;padding-left: .25rem;background-color: rgba(13, 41, 50, 0.8); border: 0; border-radius: .15rem;
                        position: absolute;
                        top: .3rem;
                        left: 0;
                        "
                    @keyup.enter="submitForm('ruleForm2')"
                  />
                  <!-- <img :src="verifyImg" alt class="verifyImg" @click="getcode()" style="
                      position: absolute;
                        top: .3rem;
                        right: 0;" /> -->
                  <div
                    class="verifyImg"
                    style="position: absolute;top: .3rem;right: 0;display: flex;justify-content: center;align-items: center;cursor:pointer;"
                    @click="createdCode()"
                  >
                    <div>
                      <span
                        v-for="(item, index) in codeList"
                        :key="index"
                        :style="getStyle(item)"
                        >{{ item.code }}</span
                      >
                    </div>
                  </div>
                </el-form-item>
                <div class="checkagreement">
                  <span class="c2">登录即同意</span>
                  <div class="c3" style="cursor:pointer;" @click="agreement">
                    《用户协议》
                  </div>
                  <div
                    class="c8"
                    style="cursor:pointer;"
                    @click="agreementmode"
                  >
                    《用户协议》
                  </div>
                  <div class="c4"></div>
                  <el-dialog
                    :visible.sync="dialogVisible"
                    append-to-body
                    width="30%"
                    style="margin-top:100px; z-index: 100000;"
                  >
                    <div
                      style=" position: absolute;top: 20px;left: 250px;font-size: 20px; color: #222222;"
                    >
                      {{ protocolrList.title }}
                    </div>
                    <div
                      style=" position: absolute;top: 60px;left: 35px;font-size: 20px; color: #222222;width: 510px; height: 1px; background-color: #a3a3a3;"
                    ></div>
                    <div
                      class="gundong"
                      style=" font-size: 20px; color: #222222;width: 480px; height: 305px; margin:58px auto 0; overflow: auto;"
                    >
                      <p
                        style="font-size:14px"
                        v-html="protocolrList.content"
                      ></p>
                    </div>
                    <span
                      slot="footer"
                      class="dialog-footer"
                      style="display:flex;"
                    >
                      <el-button @click="dialogVisible = false" style="flex:1;"
                        >不同意</el-button
                      >
                      <el-button @click="checkgou" style="flex:1;"
                        >同 意</el-button
                      >
                    </span>
                  </el-dialog>
                  <el-dialog
                    :visible.sync="dialogVisiblemode"
                    append-to-body
                    width="90%"
                    :show-close="false"
                    style="margin-left: 10rem;z-index: 100000;"
                  >
                    <div
                      style=" position: absolute;top: 3rem;left: 37rem;font-size: 20px; color: #222222;"
                    >
                      {{ protocolrList.title }}
                    </div>
                    <div
                      style=" position: absolute;top:15rem;left: 0rem;font-size: 20px; color: #222222;width: 100%; height: 1px; background-color: #a3a3a3;"
                    ></div>
                    <div
                      class="gundong"
                      style=" font-size: 20px; color: #222222;width: 100%; height:130rem; margin: auto 0; overflow: auto;"
                    >
                      <p
                        style="font-size:14px"
                        v-html="protocolrList.content"
                      ></p>
                    </div>
                    <span
                      slot="footer"
                      class="dialog-footer"
                      style="display:flex;"
                    >
                      <el-button @click="checkgoumode" style="flex:1;"
                        >不同意</el-button
                      >
                      <el-button @click="checkgou" style="flex:1;"
                        >同 意</el-button
                      >
                    </span>
                  </el-dialog>
                </div>
                <button
                  type="button"
                  name="button"
                  class="loginBtn"
                  @click="submitForm('ruleForm2')"
                >
                  登 录
                </button>
              </el-tabs>
              <!-- <h1>共克时艰版</h1> -->
              <div
                style="display: flex;justify-content: space-between;margin-top: .2rem;"
              >
                <div>
                  <span class="registerBtnzz">
                    还没有注册?
                  </span>
                  <span
                    type="button"
                    name="button"
                    class="registerBtn"
                    @click="tabChange3"
                    data-id="3"
                    >注 册
                  </span>
                </div>
                <div style="text-align: right;width: .9rem; ">
                  <a
                    style="color: #5dbbda;cursor:pointer;font-size: .16rem;"
                    type="text"
                    @click="tabChange4"
                    data-id="5"
                    >忘记密码?</a
                  >
                </div>
              </div>
            </el-form>
          </div>
          <div class="Scanning_code" v-show="tab == 2">
            <div class="tt" style="margin-top: .1rem;">
              <span
                @click="tabChange1"
                data-id="1"
                :style="{ color: activeColor1 }"
                style="cursor:pointer;"
                >账号登录</span
              ><img src="../../../static/img2/shux.png" alt="" /><span
                @click="tabChange2"
                data-id="2"
                :style="{ color: activeColor2 }"
                style="cursor:pointer;"
                >扫码登录</span
              >
            </div>
            <div
              style="width: 3rem;height: 3rem;display: flex;flex-direction: column;justify-content: space-between;align-items: center;margin-top: .4rem;margin-left: .54rem;"
            >
              <div
                v-if="timecode >= 180"
                @click="setqrcode()"
                style="cursor:pointer;width: 3.2rem;height: 3.2rem;display: flex;justify-content: center;z-index: 9999;position: absolute;background-color:rgba(0,0,0,.8);"
              >
                <img
                  src="../../assets/img/shuxin.png"
                  style="width: .8rem;height: .8rem; border-radius: .5rem;margin-top: .6rem;z-index: 100;"
                  alt=""
                />
                <p style="margin-top: 160px;color: #fff;">
                  二维码失效，点击重试
                </p>
              </div>
              <div
                style="margin-top: 80px;z-index: 100;position: absolute"
                v-if="!getgenerateQRCode"
              >
                <i class="el-icon-loading" style="font-size: 60px;"></i>
              </div>
              <img
                src="../../assets/img/众绘logo-011.jpg"
                v-if="getgenerateQRCode"
                style="width: 1.42rem;height: 1.42rem; border-radius: 50%;margin-top: .9rem;z-index: 1000;"
                alt=""
              />
              <img
                :src="'data:text/css;base64,' + getgenerateQRCode"
                v-if="getgenerateQRCode"
                style="width: 3.2rem;height: 3.2rem;"
              />

              <div
                style="margin-top: 3.4rem;display: flex;flex-direction: column;justify-content: center;align-items: center;color: #fff;font-size: .18rem;"
              >
                <p>使用微信扫一扫登录</p>
                <p>“众绘虚拟现实”</p>
              </div>
            </div>
            <!-- <wxlogin :appid="appid"
              :href="'data:text/css;base64,LmxvZ2luUGFuZWwgLnRpdGxlewogICAgZGlzcGxheTogbm9uZTsKICB9CiAuaW1wb3dlckJveCAucXJjb2RlIHsKICAgIHdpZHRoOiAyMTVweDsKICAgIG1hcmdpbi10b3A6IDE1cHg7Cn0KLmltcG93ZXJCb3ggLnN0YXR1cyBwIHsKICAgIGZvbnQtc2l6ZTogMTNweDsKICAgIGNvbG9yOiAjZmZmOwp9'"<img
              :scope="scope" :redirect_uri="redirect_uri" style="width: 100%; position: absolute;top:50px;left: 30px;">
            </wxlogin> -->
          </div>
          <div class="register" v-show="tab == 3" style="margin-top: .1rem;">
            <div
              style="color:#fff;font-size: .18rem;position: absolute;
                  left: 1.5rem;"
            >
              欢迎您注册
            </div>
            <el-form
              :model="register"
              :rules="rulesBind"
              ref="register"
              style="width: 80%;margin-left: 10%;"
              :center="true"
            >
              <el-form-item prop="username" class="form-group">
                <img
                  src="../../../static/img2/usericon.png"
                  class="passwordicon"
                  style="position: absolute;top: .56rem;left: 0px;width: .12rem;height: .14rem;z-index: 1000;"
                  alt=""
                />
                <img
                  src="../../../static/img2/shux.png"
                  style="width:.02rem ;height:.15rem ;padding-left: .3rem;padding-top:.56rem;z-index:1000"
                  alt=""
                />
                <input
                  class="regis1"
                  v-model="register.username"
                  placeholder="请输入账号"
                  @input="inputPhone"
                />
                <p
                  style="color:#9b2525;position: absolute;font-size: .12rem;line-height: .15rem;top: .68rem;left: 1.8rem;"
                  class="err"
                  id="err_phonenum"
                  v-show="phoneerrmsgg"
                >
                  <span>{{ phoneerrmsg }}</span>
                </p>
              </el-form-item>
              <el-form-item prop="password" class="form-group">
                <img
                  src="../../../static/img2/passwordicon.png"
                  class="passwordicon"
                  style="position: absolute;top: .92rem;left: 0px;width: .12rem;height: .14rem;z-index: 1000;"
                  alt=""
                />
                <img
                  src="../../../static/img2/shux.png"
                  style="width:.02rem ;height:.15rem ;padding-left: .3rem;padding-top:.92rem;z-index:1000"
                  alt=""
                />
                <input
                  class="regis2"
                  :type="passwordType"
                  v-model="register.password"
                  placeholder="请输入密码"
                  @input="inputPhonePASS"
                />
                <p
                  style="color:#9b2525;position: absolute;font-size: .13rem;line-height: .15rem;top: 1.22rem;left: .16rem;"
                  class="err"
                  id="err_phonenum"
                  v-show="phoneerrmsggpass"
                >
                  <span>{{ phoneerrmsgpass }}</span>
                </p>
                <img
                  :src="paSrc"
                  style="width:.17rem ;height:.08rem ; position:absolute;top:.96rem;right:.1rem;z-index: 10000;"
                  alt=""
                  @click="changePassward"
                />
              </el-form-item>
              <el-form-item prop="mobile" class="form-group">
                <img
                  src="../../../static/img2/molidicon.png"
                  class="passwordicon"
                  style="position: absolute;top: 1.28rem;left: 0px;width: .1rem;height: .16rem;z-index: 1000;"
                  alt=""
                />
                <img
                  src="../../../static/img2/shux.png"
                  style="width:.02rem;height:.15rem ;padding-left: .3rem;padding-top:1.28rem;z-index:1000"
                  alt=""
                />
                <input
                  class="regis3"
                  v-model="register.mobile"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item class="form-group" prop="verification">
                <input
                  class="regis4"
                  v-model="verification_code"
                  placeholder="请输入验证码"
                />
                <div style="position: absolute;top: 2rem;left: 0;">
                  <img
                    class="c1"
                    src="../../../static/img2/shicheck.png"
                    @click="checkgou"
                    alt=""
                  />
                  <img
                    class="c5"
                    src="../../../static/img2/gouxiaun.png"
                    @click="checkgou"
                    v-show="tickk"
                    alt=""
                  />
                  <span class="c2">同意</span>
                  <span class="c3" style="cursor:pointer;" @click="agreement2"
                    >《用户协议》</span
                  >
                  <span
                    class="c3mode"
                    style="cursor:pointer;"
                    @click="agreementmode2"
                    >《用户协议》</span
                  >
                  <div class="c4"></div>
                  <el-dialog
                    :visible.sync="dialogVisible2"
                    append-to-body
                    width="30%"
                    style="margin-top:100px;
                                "
                  >
                    <div
                      style=" position: absolute;top: 20px;left: 250px;font-size: 20px; color: #222222;"
                    >
                      {{ protocolrList.title }}
                    </div>
                    <div
                      style=" position: absolute;top: 60px;left: 35px;font-size: 20px; color: #222222;width: 510px; height: 1px; background-color: #a3a3a3;"
                    ></div>
                    <div
                      class="gundong"
                      style=" font-size: 20px; color: #222222;width: 480px; height: 305px; margin:58px auto 0; overflow: auto;"
                    >
                      <p
                        style="font-size:14px"
                        v-html="protocolrList.content"
                      ></p>
                    </div>
                    <span
                      slot="footer"
                      class="dialog-footer"
                      style="display:flex;"
                    >
                      <el-button @click="dialogfase" style="flex:1;"
                        >不同意</el-button
                      >
                      <el-button @click="checkgou" style="flex:1;"
                        >同 意</el-button
                      >
                    </span>
                  </el-dialog>
                  <el-dialog
                    :visible.sync="dialogVisiblemode2"
                    append-to-body
                    width="90%"
                    :show-close="false"
                    style="margin-left: 10rem;z-index: 100000;"
                  >
                    <div
                      style=" position: absolute;top: 3rem;left: 37rem;font-size: 20px; color: #222222;"
                    >
                      {{ protocolrList.title }}
                    </div>
                    <div
                      style=" position: absolute;top:15rem;left: 0rem;font-size: 20px; color: #222222;width: 100%; height: 1px; background-color: #a3a3a3;"
                    ></div>
                    <div
                      class="gundong"
                      style=" font-size: 20px; color: #222222;width: 100%; height:130rem; margin: auto 0; overflow: auto;"
                    >
                      <p
                        style="font-size:14px"
                        v-html="protocolrList.content"
                      ></p>
                    </div>
                    <span
                      slot="footer"
                      class="dialog-footer"
                      style="display:flex;"
                    >
                      <el-button @click="checkgoumode" style="flex:1;"
                        >不同意</el-button
                      >
                      <el-button @click="checkgou" style="flex:1;"
                        >同 意</el-button
                      >
                    </span>
                  </el-dialog>
                </div>
                <button
                  :disabled="disabled"
                  :class="{ right_phone: rightPhone }"
                  @click.prevent="getCode"
                  style="width:1.11rem;height: .38rem;border: 0;position: absolute;top: 1.5rem;
                                  left: 2.3rem;border-radius: .15rem;background-color: rgba(14, 44, 53, 0.8);color: #fff;border: 1px solid #00c1ff;font-size: .16rem;"
                >
                  {{
                    computeTime > 0 ? `(${computeTime}s)已发送` : "获取验证码"
                  }}
                </button>
              </el-form-item>
              <div
                style="margin-top: 2.5rem;display: flex;justify-content: space-between;width: 3.5rem;margin-left: -.1rem;"
              >
                <el-button
                  @click="tab = 1"
                  style="width:1.43rem;height: .4rem;border: 0;border-radius: .25rem;background-color: #00c1ff;color: #fff;font-size: .16rem;line-height: .1rem;"
                  >取 消
                </el-button>
                <el-button
                  type="primary"
                  style="width:1.43rem;height: .4rem;border: 0;border-radius: .25rem;background-color: #00c1ff;color: #fff;font-size: .16rem;line-height: .1rem;"
                  @click="submitRegister('register')"
                  >提 交</el-button
                >
              </div>
            </el-form>
          </div>
          <div
            class="register_succeed"
            v-show="tab == 4"
            style="display:flex;justify-content: center;"
          >
            <img
              src="../../../static/img2/succeed.png"
              style="width:128px;height: 128px;margin-top: 50px;"
              alt=""
            />
            <span style="margin-top:190px;color:#fff;font-size:18px"
              >注册成功!</span
            >
            <button
              style="width:326px;height:47px;background-color: #00c1ff;border: 0;
                    border-radius: 25px; position: absolute;
                    left: 15px;
                    top: 250px;
                    font-size: 16px;
                    color: #fff;
                    text-align: center;
                    "
              @click="tab = 1"
            >
              立 即 登 录
            </button>
          </div>
          <div class="forget" v-show="tab == 6">
            <div
              style="color:#fff;font-size:.20rem;display: flex;justify-content: center;margin-top: .20rem;font-family:'Microsoft YaHei';font-weight: 500;"
            >
              找回密码
            </div>
            <!-- <p style="position:absolute;top:.95rem;left:.20rem;color:#fff;font-size: .16rem;font-family:'Microsoft YaHei';font-weight: 600;">手机号码验证</p>
            <p style="position:absolute;top:1.18rem;left:.20rem;color:#fff;font-size: .16rem;font-family:'Microsoft YaHei';font-weight: 600;">请填写完整的手机号验证身份</p>
            <p style="position:absolute;top:1.18rem;right:.3rem;color:#5dbddd;cursor:pointer;font-size: .16rem;font-family:'Microsoft YaHei';font-weight: 600;" @click="rectonlogin">返回</p> -->
            <span
              style="color:#6ad3f6;position:absolute;top:.8rem;left:.35rem;z-index:1000;font-size: .16rem;"
              >+86</span
            >
            <el-form :model="ruleForm" label-position="right" :rules="rules">
              <el-form-item prop="title">
                <input
                  class="for1"
                  v-model="ruleForm.mobile"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item class="form-group" prop="verification_code">
                <input
                  class="for2"
                  v-model="ruleForm.verification_code"
                  placeholder="请输入验证码"
                />
                <!-- <img :src="verifyImg" alt class="verifyImg" @click="getcode()" style="
                    position: absolute;
                      top: 1.5rem;
                      right: .3rem;" /> -->
                <div
                  class="verifyImg"
                  style="position: absolute;top: .7rem;right:.3rem;display: flex;justify-content: center;align-items: center;cursor:pointer;"
                  @click="createdCode()"
                >
                  <div>
                    <span
                      v-for="(item, index) in codeList"
                      :key="index"
                      :style="getStyle(item)"
                      >{{ item.code }}</span
                    >
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitMobile"
                  style="width:3.6rem;height: .44rem;border-radius: .25rem;background-color: #00c1ff;border: 0;color: #fff;position: absolute;top: 2.1rem;left: .2rem;font-size: .16rem;"
                >
                  下一步
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="change_password1" v-show="tab == 5">
            <div
              style="color:#fff;font-size:.2rem;display: flex;justify-content: center;margin-top: .2rem;"
            >
              找回密码
            </div>
            <el-form
              :model="ruleForm"
              label-position="right"
              ref="ruleForm"
              status-icon
            >
              <el-form-item class="form-group" prop="mobile">
                <input
                  class="change3"
                  placeholder="请输入手机号"
                  type="text"
                  v-model="ruleForm.mobile"
                  autocomplete="off"
                />
              </el-form-item>
              <el-form-item class="form-group" prop="verification_code">
                <input
                  class="for2"
                  v-model="ruleForm.verification_code"
                  placeholder="请输入验证码"
                />
                <button
                  :disabled="disabled"
                  @click="getCodee()"
                  style="width:1.4rem;height: .55rem;border: 0;position: absolute;top: .6rem;left: 2.4rem;border-radius: .15rem;background-color: rgba(14, 44, 53, 0.8);color: #fff;border: 1px solid #00c1ff;text-align: center;font-size: .16rem;cursor:pointer;"
                  :class="{ right_phone: rightPhonee }"
                >
                  {{
                    computeTime > 0 ? `(${computeTime}s)已发送` : "发送验证码"
                  }}
                </button>
              </el-form-item>
              <!-- 'text' : 'password' -->
              <el-form-item class="form-group" prop="new_password">
                <img
                  src="../../../static/img2/mimachakan.png"
                  v-show="passwordTypexin"
                  style="width:.17rem ;height:.08rem; position:absolute;top:1.3rem;right:.4rem;z-index: 10000;"
                  alt=""
                  @click="passwordTypexin = !passwordTypexin"
                />
                <img
                  src="../../../static/img2/mimayic.png"
                  v-show="!passwordTypexin"
                  style="width:.17rem ;height:.08rem; position:absolute;top:1.3rem;right:.4rem;z-index: 10000;"
                  alt=""
                  @click="passwordTypexin = !passwordTypexin"
                />
                <input
                  class="change1"
                  :type="passwordTypexin ? 'password' : 'text'"
                  placeholder="请输入新密码"
                  v-model="ruleForm.new_password"
                  autocomplete="off"
                />
              </el-form-item>
              <el-form-item class="form-group" prop="new_password_repeat">
                <img
                  src="../../../static/img2/mimachakan.png"
                  v-show="passwordTypeqveren"
                  style="width:.17rem ;height:.08rem; position:absolute;top:1.78rem;right:.4rem;z-index: 10000;"
                  alt=""
                  @click="passwordTypeqveren = !passwordTypeqveren"
                />
                <img
                  src="../../../static/img2/mimayic.png"
                  v-show="!passwordTypeqveren"
                  style="width:.17rem ;height:.08rem; position:absolute;top:1.78rem;right:.4rem;z-index: 10000;"
                  alt=""
                  @click="passwordTypeqveren = !passwordTypeqveren"
                />
                <input
                  class="change2"
                  placeholder="请确认新密码"
                  :type="passwordTypeqveren ? 'password' : 'text'"
                  v-model="ruleForm.new_password_repeat"
                  autocomplete="off"
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="width:1.5rem;height: .44rem;border-radius: .25rem;background-color: #00c1ff;border: 0;color: #fff;position: absolute;top: 2rem;
                left: .4rem;line-height: .1rem;"
                  @click="
                    rectonlogin();
                    ruleForm = {};
                  "
                >
                  取消
                </el-button>
                <el-button
                  type="primary"
                  style="width:1.5rem;height: .44rem;border-radius: .25rem;background-color: #00c1ff;border: 0;color: #fff;position: absolute;top: 2rem;
                left: 2.2rem;line-height: .1rem;"
                  @click="submitHandle('ruleForm')"
                >
                  确定
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="modify_successfully"
            v-show="tab == 7"
            style="display:flex;justify-content: center;"
          >
            <img
              src="../../../static/img2/succeed.png"
              style="width:1.4rem;height: 1.4rem;margin-top: .5rem;"
              alt=""
            />
            <span style="margin-top:2.2rem;color:#fff;font-size:.18rem"
              >重置密码成功!</span
            >
            <button
              style="width:3.5rem;height:.5rem;background-color: #00c1ff;border: 0;
          border-radius: .25rem; position: absolute;
          left: .28rem;
          top: 3rem;
          font-size: .18rem;
          color: #fff;
          text-align: center;
          "
              @click="tab = 1"
            >
              立 即 登 录
            </button>
          </div>
          <el-dialog
            title="绑定账号"
            width="500px"
            :visible.sync="dialogFormVisible2"
            :modal="false"
            :before-close="handleClose"
          >
            <el-form
              :model="userInfo"
              status-icon
              :rules="rulesRegister"
              ref="rulesRegister"
              label-width="100px"
              class="ruleForm"
            >
              <el-form-item label="账号" prop="username">
                <input
                  v-model="userInfo.username"
                  style="width:200px;height:30px"
                />
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <input
                  type="password"
                  v-model="userInfo.password"
                  autocomplete="off"
                  style="width:200px;height:30px"
                />
              </el-form-item>
              <el-form-item>
                <button
                  type="primary"
                  style="width:80px; height:30px"
                  @click="bindPhone('rulesRegister')"
                >
                  绑定
                </button>
              </el-form-item>
            </el-form>
          </el-dialog>
          <el-dialog
            title="完善信息"
            :visible.sync="dialogFormVisible3"
            :modal="false"
            :before-close="handleClosews"
          >
            <el-form
              :model="userInfo"
              status-icon
              :rules="rulesRegister"
              ref="rulesRegister"
              label-width="100px"
              class="ruleForm"
            >
              <el-form-item label="账号" prop="username">
                <el-input v-model="userInfo.username"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  v-model="userInfo.password"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realname">
                <el-input v-model="userInfo.realname"></el-input>
              </el-form-item>
              <el-form-item label="选择学校" v-if="this.school_id == 100001">
                <el-select
                  v-model="userInfo.school_id"
                  placeholder="选择学校"
                  @change="handleDepart"
                >
                  <el-option
                    v-for="item in schools"
                    :key="'school' + item.id"
                    :label="item.school_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择院系">
                <el-select
                  v-model="userInfo.depart_id"
                  placeholder="选择院系"
                  @change="handleMajor"
                >
                  <el-option
                    v-for="item in departs"
                    :key="'depart' + item.id"
                    :label="item.department_name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择专业">
                <el-select
                  v-model="userInfo.major_id"
                  placeholder="选择专业"
                  @change="handleGrade"
                >
                  <el-option
                    v-for="item in majors"
                    :key="'major' + item.id"
                    :label="item.major_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择年级">
                <el-select
                  v-model="userInfo.grade_id"
                  placeholder="选择年级"
                  @change="handleClass"
                >
                  <el-option
                    v-for="item in grades"
                    :key="'grade' + item.id"
                    :label="item.grade_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择班级">
                <el-select
                  v-model="userInfo.class_id"
                  placeholder="选择班级"
                  @change="handleChange"
                >
                  <el-option
                    v-for="item in classmates"
                    :key="'classmate' + item.id"
                    :label="item.class_name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="goNext('first')"
                  >上一步</el-button
                >
                <el-button type="primary" @click="bindPhone('rulesRegister')"
                  >提交</el-button
                >
              </el-form-item>
            </el-form>
          </el-dialog>
          <div></div>
        </div>
        <div class="login-footer">
          <div>
            <p class="hrefs">
              Copyright：2019北京众绘虚拟现实技术研究院有限公司 版权所有
            </p>
            <!-- <p @click="gohref" class="hrefs">京ICP备18051304号-2</p> -->
            <p @click="gohref2" style="margin-left:.20rem" class="hrefs">
              京ICP备18051304号-4
              <img
                src="../../../static/images/beian.png"
                style="width:.16rem; margin-left: .05rem;margin-right: .05rem; margin-top:.1rem"
                alt=""
                @click="gohref2"
                class="hrefs"
              />京公网安备11011302003225号
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import wxlogin from "vue-wxlogin";
import PhoneValidate from "./PhoneValidate";
import { instance } from "../../restful/axios.js";
import { getTopDomain } from "../../utils";
export default {
  components: { wxlogin, PhoneValidate },
  name: "Login",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.userInfo.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateUserName = (rule, value, callback) => {
      var username = /^[\da-zA-Z]+$/;
      if (value === "") {
        callback(new Error("请输入账号"));
      } else if (!username.test(value)) {
        callback(new Error("账号只能为数字或字母"));
      } else {
        callback();
      }
    };

    const validatePass3 = (rule, callback, $msgForm, $refFom) => {
      // console.log($msgForm)

      if (!$msgForm.new_password) {
        callback(new Error("请输入新密码"));
        return false;
      } else {
        var rag = /^[0-9a-zA-Z]+$/;
        if (!rag.test($msgForm.new_password)) {
          callback(new Error("密码只能为数字或者英文"));
          return false;
        }
        if ($msgForm.new_password_repeat !== "") {
          $refFom.validateField("new_password_repeat");
        }
        callback();
      }
    };
    const validatePass4 = (rule, callback, $msgForm) => {
      // console.log($msgForm)
      if (!$msgForm.new_password_repeat) {
        callback(new Error("请再次输入密码"));
        return false;
      } else if ($msgForm.new_password_repeat !== $msgForm.new_password) {
        callback(new Error("两次输入密码不一致!"));
        return false;
      } else {
        var rag = /^[0-9a-zA-Z]+$/;
        if (!rag.test($msgForm.new_password_repeat)) {
          callback(new Error("密码只能为数字或者英文"));
        }
        callback();
      }
    };
    return {
      passwordTypexin: true, //新密码小眼睛
      passwordTypeqveren: true, //新密码小眼睛
      codeList: [], //随机验证码
      // showloading:true,
      cerebrum: false,
      timecode: 0,
      timergriades: "", //定时器
      getgenerateQRCode: "",
      tab: 1,
      showType: this.$route.query.user_id ? "weixin" : "mobile",
      activeName2: "first",
      disabled: false,
      schools: [],
      departs: [],
      majors: [],
      protocolrList: [],
      passwordType: "password",
      paSrc: require("../../../static/img2/mimayic.png"),
      article_id: 1,
      grades: [],
      modexeiyi: true,
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisiblemode: false,
      tick: false,
      tickk: false,
      activeColor1: "#00c1ff",
      activeColor2: "",
      classmates: [],
      class_id: "",
      userInfo: {},
      loginWay: true,
      phone: "", //手机号,
      computeTime: 0,
      verification_code: "", //验证码
      timer: null,
      verification_key: "",
      appid: "wxbe5744fb72cbb4bf",
      scope: "snsapi_login",
      bindInfo: {},
      // 扫码成功后 跳转的地址
      redirect_uri: encodeURIComponent(
        "http://www.univrlab.com/api/qrcode/callback?redirect_url=" +
          Base64.encode(window.location.href)
      ),
      activeName: "username",
      school_id: this.$store.getters.getSchoolInfo.id,
      verifyImg: "",
      key: "",
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      register: {
        school_id: this.school_id
      },
      ruleForm2: {
        username: "",
        password: "",
        verification: ""
      },
      isShow: false,
      imgUrl: "./static/images/rePhoto/",
      imgName: [
        "1.jpg",
        "2.jpg",
        "3.jpg",
        "4.jpg",
        "5.jpg",
        "6.jpg",
        "7.jpg",
        "8.jpg",
        "9.jpg",
        "10.jpg"
      ],
      secend: 0,
      active: 0,
      username1: "",
      verification_code: "",
      username: "",
      phoneerrmsgg: false,
      phoneerrmsggpass: false,
      dialogVisiblemode2: false,
      phoneerrmsg: "",
      phoneerrmsgpass: "",
      computeTime: 0,
      computeTime2: 10,
      disabled: false,
      ruleForm: {
        new_password: "",
        new_password_repeat: ""
      },
      rules: {
        new_password: [
          {
            trigger: "blur",
            required: true,
            validator: (rule, value, callback) => {
              validatePass3(rule, callback, this.ruleForm, this.$refs.ruleForm);
            }
          }
        ],
        new_password_repeat: [
          {
            trigger: "blur",
            required: true,
            validator: (rule, value, callback) => {
              validatePass4(rule, callback, this.ruleForm, this.$refs.ruleForm);
            }
          }
        ],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        verification_code: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      registerRule: {
        username: [
          { validator: validateUserName, trigger: "blur" },
          { min: 4, message: "账号最少为4位", trigger: "blur" },
          { max: 20, message: "账号过长,最长为20位", trigger: "blur" }
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          { min: 6, message: "密码最少为4位", trigger: "blur" },
          { max: 16, message: "密码过长,最长为16位", trigger: "blur" }
        ],
        realname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { max: 6, message: "姓名过长", trigger: "blur" }
        ],
        mobile: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        depart_id: [{ required: true, message: "请选择院系", trigger: "blur" }],
        major_id: [{ required: true, message: "请选择专业", trigger: "blur" }],
        grade_id: [{ required: true, message: "请选择年级", trigger: "blur" }],
        class_id: [{ required: true, message: "请选择班级", trigger: "blur" }]
      },

      rules2: {
        username: [
          { validator: validateUserName, trigger: "blur" },
          { min: 4, message: "账号最少为4位", trigger: "blur" },
          { max: 20, message: "账号过长,最长为20位", trigger: "blur" }
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          { min: 6, message: "密码最少为4位", trigger: "blur" },
          { max: 16, message: "密码过长,最长为16位", trigger: "blur" }
        ],
        verification: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "验证码格式不正确", trigger: "blur" }
        ]
      },

      rulesBind: {
        username: [
          { validator: validateUserName, trigger: "blur" },
          { min: 4, message: "账号最少为4位", trigger: "blur" },
          { max: 20, message: "账号过长,最长为20位", trigger: "blur" }
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          { min: 6, message: "密码最少为4位", trigger: "blur" },
          { max: 16, message: "密码过长,最长为16位", trigger: "blur" }
        ]
      },
      rulesRegister: {
        username: [
          { validator: validateUserName, trigger: "blur" },
          { min: 4, message: "账号最少为4位", trigger: "blur" },
          { max: 20, message: "账号过长,最长为20位", trigger: "blur" }
        ],
        password: [
          { validator: validatePass, trigger: "blur" },
          { min: 6, message: "密码最少为4位", trigger: "blur" },
          { max: 20, message: "密码过长,最长为20位", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 验证码
    createdCode() {
      const len = 4;
      const codeList = [];
      const chars = "abcdefhijkmnprstwxyz0123456789";
      const charsLen = chars.length;
      // 生成
      for (let i = 0; i < len; i++) {
        const rgb = [
          Math.round(Math.random() * 220),
          Math.round(Math.random() * 240),
          Math.round(Math.random() * 200)
        ];
        codeList.push({
          code: chars.charAt(Math.floor(Math.random() * charsLen)),
          color: `rgb(${rgb})`,
          fontSize: `.2${[Math.floor(Math.random() * 10)]}rem`,
          padding: `.0${[Math.floor(Math.random() * 10)]}rem`,
          transform: `rotate(${Math.floor(Math.random() * 90) -
            Math.floor(Math.random() * 90)}deg)`
        });
      }
      // 指向
      this.codeList = codeList;
    },
    getStyle(data) {
      return `color: ${data.color}; font-size: ${data.fontSize}; padding: ${data.padding}; transform: ${data.transform}`;
    },
    // 点击重新加载二维码
    setqrcode() {
      this.getgenerateQRCode = "";
      this.timecode = 0;
      this.getQRCode();
    },
    // 监听微信授权
    Listening(code) {
      this.$http.checkQRCode({ scene: code }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.getUserInfo();
          clearInterval(this.timergriades);
          for (let key in res.data) {
            this.$cookies.set(key, res.data[key]);
            console.log(key, res.data[key]);
          }
        }
      });
    },
    // 获取二维码
    getQRCode() {
      this.$http.generateQRCode().then(res => {
        console.log(res);
        this.getgenerateQRCode = res.data.qrCodeUrl;
        this.timecode = 0;
        this.timergriades = setInterval(() => {
          this.timecode = this.timecode + 3;
          this.Listening(res.data.sceneId);
          if (this.timecode >= 180) {
            clearInterval(this.timergriades);
          }
          console.log(this.timecode);
        }, 3000);
      });
    },
    // 关闭绑定确认框
    handleClose() {
      this.dialogFormVisible2 = false;
    },
    // 关闭信息完善框
    handleClosews() {
      this.dialogFormVisible3 = false;
    },
    tabChange1: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
      this.activeColor1 = "#00c1ff";
      this.activeColor2 = "#fff";
    },
    tabChange2: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
      this.activeColor2 = "#00c1ff";
      this.activeColor1 = "#fff";
      this.setqrcode();
    },
    tabChange3: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
    },
    tabChange4: function(e) {
      let tabid = e.target.dataset.id;
      this.tab = tabid;
    },
    getSchoolInfo() {
      var domain_name = getTopDomain();
      this.$http.schoolInfo({ domain_name: domain_name }).then(res => {
        this.$store.commit("SetSchoolInfo", res.data);
        this.school_id = res.data.id;
      });
    },
    rectonlogin() {
      this.tab = 1;
    },
    goNext(tab) {
      if (!this.verification_key) {
        this.$message.error("请获取验证码！");
        return false;
      }
      this.activeName2 = tab;
    },
    inputPhone(e) {
      this.phoneerrmsg = "请输入数字或者大小写字母"; //验证输入的提示信息
      let filtered = e.target.value.replace(/^0|[^\d a-zA-Z]/g, "");
      if (this.register.username != filtered) {
        this.phoneerrmsgg = true;
      } else {
        this.phoneerrmsgg = false;
      }
      //console.log(this.phone.length,this.phone,e)
    },
    gohref2() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302003225"
      );
    },
    inputPhonePASS(e) {
      this.phoneerrmsgpass = "请输入包含⼤⼩写字母数字特殊字符"; //验证输入的提示信息
      let filtered = e.target.value.replace(/^0|[^\d a-zA-Z ~!@#$%^&*]/g, "");
      console.log(e.target.value.length);
      if (this.register.password != filtered) {
        this.phoneerrmsggpass = true;
      } else {
        this.phoneerrmsggpass = false;
      }
      if (e.target.value.length < 8) {
        this.phoneerrmsggpass = true;
      }
      // console.log(this.phone.length,this.phone,e)
    },
    handleSchool() {
      if (this.school_id == 100001) {
        this.$http.school().then(res => {
          this.schools = res.data;
        });
      } else {
        this.handleDepart(this.school_id);
      }
    },
    // 切换密码显示隐藏
    changePassward() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
      this.paSrc =
        this.paSrc == require("../../../static/img2/mimayic.png")
          ? require("../../../static/img2/mimachakan.png")
          : require("../../../static/img2/mimayic.png");
    },
    dialogfase() {
      this.tickk = false;
      this.dialogVisible = false;
      this.dialogVisible2 = false;
    },
    agreement2() {
      this.dialogVisible2 = true;
      this.article_id = 1;
      let dataid = {
        article_id: 1
      };
      this.$http.articleList(dataid).then(res => {
        if (res.code !== 0) {
          if (res.data) {
            this.protocolrList = res.data;
            console.log(this.protocolrList);
          }
        }
      });
    },
    agreement() {
      this.dialogVisible = true;
      this.article_id = 1;
      let dataid = {
        article_id: 1
      };
      this.$http.articleList(dataid).then(res => {
        if (res.code !== 0) {
          if (res.data) {
            this.protocolrList = res.data;
            console.log(this.protocolrList);
          }
        }
      });
    },
    agreementmode() {
      this.dialogVisiblemode = true;
      this.modexeiyi = false;
      this.article_id = 1;
      let dataid = {
        article_id: 1
      };
      this.$http.articleList(dataid).then(res => {
        if (res.code !== 0) {
          if (res.data) {
            this.protocolrList = res.data;
            console.log(this.protocolrList);
          }
        }
      });
    },
    agreementmode2() {
      this.dialogVisiblemode2 = true;
      this.modexeiyi = false;
      this.article_id = 1;
      let dataid = {
        article_id: 1
      };
      this.$http.articleList(dataid).then(res => {
        if (res.code !== 0) {
          if (res.data) {
            this.protocolrList = res.data;
            console.log(this.protocolrList);
          }
        }
      });
    },
    submitHandle(formName) {
      var rag = /^[0-9a-zA-Z]+$/;
      if (!this.rightPhonee()) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      if (!this.ruleForm.verification_code) {
        this.$message.error("请输入验证码");
        return false;
      }
      // 验证新密码
      if (!this.ruleForm.new_password) {
        this.$message.error("请输入新密码");
        return false;
      } else if (!rag.test(this.ruleForm.new_password)) {
        this.$message.error("密码只能为数字或者英文");
        return false;
      }
      // 验证确认密码
      if (!this.ruleForm.new_password_repeat) {
        this.$message.error("请确认新密码");
        return false;
      } else if (!rag.test(this.ruleForm.new_password_repeat)) {
        this.$message.error("密码只能为数字或者英文");
        return false;
      }
      if (this.ruleForm.new_password_repeat != this.ruleForm.new_password) {
        this.$message.error("两次密码不一致");
        return false;
      }
      this.$http.checkMobile(this.ruleForm).then(res => {
        if (res.code != 0) {
          this.username1 = res.data.username;
          this.$refs[formName].validate(valid => {
            if (valid) {
              var params = this.ruleForm;
              params.verification_key = this.verification_key;
              this.$http.forgetPassword(params).then(res => {
                if (res.code !== 0) {
                  this.username = res.data.username;
                  this.tab = 7;
                  this.pageNextHandle();
                  this.timer2 = setInterval(() => {
                    this.computeTime2--;
                    if (this.computeTime2 <= 0) {
                      clearInterval(this.timer2);
                      this.goLogin();
                    }
                  }, 1000);
                } else {
                  this.$message.error(res.message);
                }
              });
            } else {
              this.$message.error("请按照要求输入正确的数据");
              return false;
            }
          });
        } else {
          this.$message.error(res.message);
          this.computeTime = 0;
          this.tab = 3;
        }
      });
    },
    handleDepart(i) {
      this.departs = [];
      this.majors = [];
      this.grades = [];
      this.classmates = [];
      this.userInfo.depart_id = "";
      this.userInfo.major_id = "";
      this.userInfo.grade_id = "";
      this.userInfo.class_id = "";
      this.$http.depart({ school_id: i }).then(res => {
        this.departs = res.data;
      });
    },
    handleMajor(i) {
      this.majors = [];
      this.grades = [];
      this.classmates = [];
      this.userInfo.major_id = "";
      this.userInfo.grade_id = "";
      this.userInfo.class_id = "";
      this.$http.major({ depart_id: i }).then(res => {
        this.majors = res.data;
      });
    },
    handleGrade(i) {
      this.grades = [];
      this.classmates = [];
      this.userInfo.grade_id = "";
      this.userInfo.class_id = "";
      this.$http.grade({ major_id: i }).then(res => {
        this.grades = res.data;
      });
    },

    handleClass(i) {
      this.classmates = [];
      this.userInfo.class_id = "";
      this.$http.getclass({ grade_id: i }).then(res => {
        this.classmates = res.data;
      });
    },
    handleChange() {
      this.$forceUpdate();
    },

    rightPhone() {
      //利用正则对手机号匹配
      return /^1[0-9]{10}$/.test(this.register.mobile);
    },
    rightPhonee() {
      //利用正则对手机号匹配
      return /^1[0-9]{10}$/.test(this.ruleForm.mobile);
    },
    submitMobile() {
      if (!this.ruleForm.mobile) {
        return this.$message.error("该输入手机号");
      }
      if (!this.rightPhonee()) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      if (!this.ruleForm.verification_code) {
        this.$message.error("请输入验证码！");
        return false;
      }
      // var params = {
      //   captcha: this.ruleForm.verification_code,
      //   key: this.key,
      // }
      // this.$http.validateCode(params).then((res) => {
      //   if (res.code == 200) {
      //     this.getCodee()
      //     this.tab = 6
      //   } else {
      //     this.getcode()
      //     this.$message.error(res.message)
      //   }
      // })
      if (
        this.ruleForm.verification_code ===
        this.codeList.map(item => item.code).join("")
      ) {
        this.getCodee();
        this.tab = 6;
      } else {
        this.createdCode();
        this.$message.error("验证码不正确");
      }
      /* this.$http.checkMobile(this.ruleForm).then(res => {
        this.username1 = res.data.username
        console.log(res)
        if (res.code != 0) {
          this.tab = 6
        } else {
          this.$message.error(res.message + '，请联系学校管理员')
        }
      })*/
    },
    getCode() {
      if (!this.register.mobile) {
        return this.$message.error("请输入手机号");
      }
      if (!this.rightPhone()) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      this.$http
        .verificationCodes({ phone: this.register.mobile })
        .then(res => {
          if (res.key) {
            this.verification_key = res.key;
            if (!this.computeTime) {
              this.computeTime = 60;
              this.disabled = true;
              this.timer = setInterval(() => {
                this.computeTime--;
                if (this.computeTime <= 0) {
                  clearInterval(this.timer);
                  this.disabled = false;
                }
              }, 1000);
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          // console.log(err)
        });
    },
    getCodee() {
      if (!this.rightPhonee()) {
        this.$message.error("请输入正确的手机号");
        return false;
      }

      this.$http
        .verificationCodes2({ phone: this.ruleForm.mobile })
        .then(res => {
          if (res.key) {
            this.verification_key = res.key;
            if (!this.computeTime) {
              console.log(this.computeTime);
              this.computeTime = 60;
              this.disabled = true;
              this.timer = setInterval(() => {
                this.computeTime--;
                if (this.computeTime <= 0) {
                  clearInterval(this.timer);
                  this.disabled = false;
                }
              }, 1000);
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          // console.log(err)
        });
    },
    bindPhone(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.userInfo;
          params.time = this.$route.query.time;
          this.$http
            .bindUser(params)
            .then(res => {
              // console.log(res)
              if (res.code == 200) {
                for (let key in res.data) {
                  this.$cookies.set(key, res.data[key]);
                }
                this.getUserInfo();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(err => {
              // console.log(err)
            });
        } else {
          this.$message.error("请按格式输入！");
          return false;
        }
      });
    },
    checkAuth() {
      if (this.$route.query.need_bind == 1) {
        this.dialogFormVisible2 = true;
      }
      if (this.$route.query.user_id) {
        this.$http
          .autoLogin({ user_id: this.$route.query.user_id })
          .then(res => {
            if (res.code == 0) {
              this.dialogFormVisible2 = true;
            } else {
              for (let key in res.data) {
                this.$cookies.set(key, res.data[key]);
              }
              this.getUserInfo();
            }
          })
          .catch(err => {
            // console.log(err.response.data)
            this.$message.error(err.response.data.message);
          });
      }
    },
    checkgou() {
      this.tick = true;
      this.tickk = !this.tickk;
      this.modexeiyi = true;
      this.dialogVisible = false;
      this.dialogVisible2 = false;
      this.dialogVisiblemode = false;
      this.dialogVisiblemode2 = false;
    },
    checkgoumode() {
      this.dialogVisiblemode = false;
      this.modexeiyi = true;
      this.dialogVisiblemode2 = false;
      this.tickk = false;
    },
    submitRegister(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params1 = {
            verification_key: this.verification_key,
            verification_code: this.verification_code,
            mobile: this.register.mobile,
            username: this.register.username,
            password: this.register.password,
            user_id: this.$route.query.user_id
          };
          if (this.verification_code == "") {
            this.$message.error("验证码不能为空");
          }
          if (this.tickk == true) {
            this.$http.userRegister(params1).then(res => {
              if (res.code == 200) {
                this.tab = 4;
              } else if (this.verification_code != this.verification_key) {
                this.$message.error("请输入正确验证码");
              }
            });
          } else {
            this.$message.error("请勾选协议");
            return false;
          }
        } else {
        }
      });
    },
    test(i) {
      var message = "";
      if (i.getModifierState("CapsLock")) {
        message = "大写锁定已打开";
      } else {
        message = "大写锁定已关闭";
      }
      this.$notify.warning({
        title: "提示",
        message: message,
        showClose: false,
        position: "bottom-left",
        duration: 500
      });
    },
    doLogin(formName) {
      this.submitForm(formName);
    },
    changeCodeImg: function() {
      this.verifyImg = "/wkt-pcapis/login/image?r=" + Math.random();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.validateCode();
          return;
        } else {
          this.$message.error("请输入正确的账号密码");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    loginHandler() {
      let params = {
        username: this.ruleForm2.username,
        password: this.ruleForm2.password,
        school_id: this.school_id
      };
      this.$http
        .userLogin(params)
        .then(res => {
          if (res.code == 200) {
            for (let key in res.data) {
              this.$cookies.set(key, res.data[key]);
              console.log(key, res.data[key]);
            }
            this.getUserInfo();
          } else {
            this.$message.error(res.message);
            this.getcode();
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    checkLogin() {
      if (this.$cookies.get("token")) {
        this.$router.push({ name: "myInfo" });
      }
    },
    getUserInfo() {
      this.$http.getUserInfo().then(res => {
        // 分发actions中getUserInfo方法  找store/index.js
        this.$store.dispatch("SetUserInfo", res.data);
        //返回之前的前面

        this.$router.push(
          this.$route.params.redirect
            ? { path: this.$route.params.redirect }
            : { name: "practiceList" }
        );
      });
    },
    //获取验证码
    getcode() {
      this.$http.getCode().then(res => {
        this.key = res.data.url.key;
        this.verifyImg = res.data.url.img;
      });
    },
    //验证验证码
    validateCode() {
      console.log();
      if (
        this.ruleForm2.verification ===
        this.codeList.map(item => item.code).join("")
      ) {
        this.loginHandler();
      } else {
        this.createdCode();
        this.$message.error("验证码不正确");
      }
    },
    setRem() {
      console.log("非移动设备");
      // 基准大小
      const baseSize = 100;
      const basePc = baseSize / 1920; // 表示1920的设计图,使用100PX的默认值
      let vW = window.innerWidth; // 当前窗口的宽度
      const vH = window.innerHeight; // 当前窗口的高度
      // 非正常屏幕下的尺寸换算
      const dueH = (vW * 1080) / 1920;
      if (vH < dueH) {
        // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        vW = (vH * 1920) / 1080;
      }
      const rem = vW * basePc; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + "px";
    },
    getboxbody() {
      // 浏览器工具栏、页面缩放和 Windows 显示缩放都会改变 CSS 视口大小。
      // 1920×1080 屏幕在 Edge 中常见为 1536×864，原判断会误隐藏模型。
      if (
        document.body.clientWidth >= 1200 &&
        document.body.clientHeight >= 650
      ) {
        this.cerebrum = true;
      } else {
        this.cerebrum = false;
      }
    }
  },
  created() {
    this.checkAuth();
    this.checkLogin();
    this.getcode();
    this.getSchoolInfo();
    this.handleSchool();
  },
  mounted() {
    this.setRem();
    this.getboxbody();
    this.createdCode();
    window.onresize = () => {
      return (() => {
        this.setRem();
        this.getboxbody();
      })();
    };
  },
  beforeDestroy() {
    clearInterval(this.timergriades);
  }
};
</script>
<style lang="less" scoped>
body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
body,
html {
  margin: 0;
  padding: 0;
  // background: #4e546c;
  height: 100%;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-weight: 400;
  overflow: hidden !important;
  -webkit-font-smoothing: antialiased;
}

#app {
  height: 100%;
  min-height: 100%;
  overflow-y: auto;
}
/deep/.el-form-item__error {
  padding-top: 60px;
}
.bottomlogo {
  position: absolute;
  top: 807px;
  left: 771px;
}

.headers {
  position: absolute;
  left: 20px;
  top: 1%;
  height: 5%;
}

input::-webkit-input-placeholder {
  color: #a7b6c3;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #a7b6c3;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #a7b6c3;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a7b6c3;
}
.test_big {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .imgbox {
    width: 100%;
    height: 100%;
    position: absolute;
    // min-height: 1000px;
    // min-width: 1950px;
  }

  .login {
    // position: absolute;
    position: fixed;
    // top: 50%;
    // left: 50%;
    width: 100vw;
    height: 100vh;
    // min-width: 1980px;
    // min-height: 1080px;
    // transform: translate(-50%, -50%);
    // transform-origin: left top;
    // transform-origin: center;
    transform-origin: center center;
  }
}

.login {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;

  //  max-width: 1200px;
  .gk {
    position: absolute;
    z-index: 11;
    left: 2.4rem;
    top: 2.4rem;
    width: 5.4rem;
    height: 0.6rem;
  }

  .iframe {
    position: absolute;
    // 背景设计稿为 1920×1080，圆心坐标约为 (1360, 520)。
    // 使用百分比定位和尺寸，避免浏览器缩放或视口差异造成偏移。
    left: 70.833333%;
    top: 44.148148%;
    width: 31.25%;
    height: 81.481481%;
    transform: translate(-50%, -50%);

    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  .imgbox {
    width: 100%;
    height: 100%;
    position: absolute;
    min-height: 1000px;
    min-width: 1950px;
  }

  .imgboxdsd {
    position: absolute;
    top: 2.4rem;
    left: 2rem;
    width: 6.2rem;
    height: 6.2rem;
  }

  .login-footer {
    width: 100%;
    height: 1.4rem;
    /* line-height: 50px; */
    position: absolute;
    top: 9.6rem;
    left: 8.2rem;
    font-size: 0.16rem;
    color: #4e546c;
    overflow: hidden;
  }

  .hrefs {
    cursor: pointer;
    color: #fff;
    font-size: 0.18rem;
  }

  .el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 14px;
  }

  .el-checkbox__inner {
    border: 2px solid #237fcc;
  }

  .login-header {
    /*background-color: #fff;*/
    height: 100px;

    .zlyun {
      height: 60px;
      margin-left: 44px;
      margin-right: 23px;
      padding-top: 30px;
    }

    .zlysxy {
      width: 217px;
      height: 34px;
    }
  }

  .login-body {
    position: relative;
    // min-height: 650px;

    .change_password1 {
      .dangqina {
        position: absolute;
        top: 60px;
        left: 30px;
        color: #00c1ff;
      }

      .change1 {
        width: 3.2rem;
        height: 0.55rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.49rem;
        color: #fff;
        position: absolute;
        top: 1.06rem;
        left: 0.2rem;
        // -webkit-text-security: disc !important;
        font-size: 0.16rem;
      }

      .change2 {
        width: 3.2rem;
        height: 0.55rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.49rem;
        color: #fff;
        position: absolute;
        top: 1.51rem;
        left: 0.2rem;
        // -webkit-text-security: disc !important;
        font-size: 0.16rem;
      }
      .change3 {
        width: 3.2rem;
        height: 0.55rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.49rem;
        color: #fff;
        position: absolute;
        top: 0.15rem;
        left: 0.2rem;
        font-size: 0.16rem;
      }
      .for2 {
        width: 1.6rem;
        height: 0.55rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.49rem;
        color: #fff;
        position: absolute;
        top: 0.6rem;
        left: 0.2rem;
        font-size: 0.16rem;
      }
    }

    .forget {
      .for1 {
        width: 2.9rem;
        height: 0.5rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.69rem;
        color: #fff;
        position: absolute;
        top: 0.18rem;
        left: 0.2rem;
        font-size: 0.16rem;
      }

      .for2 {
        width: 1.56rem;
        height: 0.5rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.25rem;
        color: #fff;
        position: absolute;
        top: 0.7rem;
        left: 0.2rem;
        font-size: 0.16rem;
      }
      .verifyImg {
        width: 1.3rem;
        height: 0.45rem;
        background: #fff;
        position: absolute;
        right: 0.4rem;
        top: 1rem;
        border-radius: 0.04rem;
      }
    }

    .register {
      .c1 {
        position: absolute;
        top: 0.14rem;
        left: 0;
        width: 0.14rem;
        height: 0.14rem;
      }

      .gundong::-webkit-scrollbar {
        width: 6px;
      }

      .gundong::-webkit-scrollbar-thumb {
        background: #e1e1e1;
        border-radius: 4px;
      }

      .c2 {
        position: absolute;
        top: 0.14rem;
        left: 0.2rem;
        color: #fff;
        width: 0.4rem;
        font-size: 0.16rem;
      }

      .c3 {
        position: absolute;
        top: 0.14rem;
        left: 0.55rem;
        color: #5dbcdb;
        width: 1.5rem;
        font-size: 0.16rem;
      }

      .c3mode {
        position: absolute;
        top: 0.14rem;
        left: 0.55rem;
        color: #5dbcdb;
        width: 1.5rem;
        display: none;
      }

      .c4 {
        position: absolute;
        top: 0.28rem;
        left: 0.74rem;
        width: 0.6rem;
        height: 1px;
        background-color: #5dbcdb;
      }

      .c5 {
        position: absolute;
        top: 0.17rem;
        left: 0.02rem;
        width: 0.08rem;
        height: 0.08rem;
      }

      .regis1 {
        width: 2.94rem;
        height: 0.45rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.69rem;
        color: #fff;
        position: absolute;
        top: 0.39rem;
        left: -0.2rem;
        font-size: 0.16rem;
      }

      .regis2 {
        width: 2.94rem;
        height: 0.45rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.69rem;
        color: #fff;
        position: absolute;
        top: 0.76rem;
        left: -0.2rem;
        font-size: 0.16rem;
      }

      .regis3 {
        width: 2.94rem;
        height: 0.45rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.69rem;
        color: #fff;
        position: absolute;
        top: 1.13rem;
        left: -0.2rem;
        font-size: 0.16rem;
      }

      .regis4 {
        width: 1.57rem;
        height: 0.44rem;
        background-color: rgba(14, 44, 53, 0.9);
        border: 0;
        border-radius: 0.15rem;
        padding-left: 0.25rem;
        color: #fff;
        position: absolute;
        top: 1.49rem;
        left: -0.2rem;
        font-size: 0.16rem;
      }
    }

    .loginleftImg {
      position: absolute;
      width: 34%;
      left: 10%;
      top: 50%;
      transform: translate(0, -50%);
      min-width: 450px;
    }

    .login-form {
      position: absolute;
      left: 3.07rem;
      top: 3.6rem;
      width: 25%;
      padding-bottom: 20px;
      width: 4.1rem;

      .tt {
        font-size: 0.18rem;
        text-align: center;
        width: 100%;
        height: 0.5rem;
        position: absolute;
        top: -0.1rem;
        left: 0;

        // font-weight: bold;
        color: #fff;
        z-index: 1000000;

        span {
          padding: 32px;
        }

        img {
          width: 2px;
          height: 15px;
          margin-top: 5px;
        }
      }

      // background-color: #17434d;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
      }

      .loginbox {
        position: relative;
        // left: 10px;
        margin-top: 0.1rem;
        form {
          .el-form-item__error {
            color: #ff4401;
            line-height: 0.3rem;
            padding-top: 0.04rem;
            position: absolute;
            top: 0.4rem;
            left: 0.53rem;
            height: 0.3rem;
            background-color: #ffc7b2;
            border-radius: 0.04px;
            border: solid 1px #ff4401;
            font-size: 0.14rem;
            padding: 0 0.1;
            box-sizing: border-box;
            z-index: 10;

            &:after {
              content: "";
              position: absolute;
              width: 18px;
              height: 18px;
              top: 9px;
              left: 10px;
            }

            &:before {
              content: "";
              position: absolute;
              width: 12px;
              height: 6px;
              top: -5px;
              left: 12px;
            }
          }

          padding: 0 6%;

          h1 {
            text-align: center;
            margin: 16px 0 16px 0;
            // font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            color: #282b29;
            line-height: 1;
          }

          .form-group {
            width: 100%;
            height: 0.5rem;
            margin: 0 auto;
            margin-bottom: 16px;
            position: relative;

            label {
              position: absolute;
              top: 50%;
              margin-top: -11px;
              left: 14px;
              margin-right: 10px;
              z-index: 99;
              width: 20px;
              height: 22px;
              display: inline-block;
            }

            .nameicon {
              &:before {
                position: absolute;
                width: 20px;
                height: 22px;
                content: "";
                background: url("../../../static/images/user.png") no-repeat;

                background-size: 20px 22px;
              }
            }

            .mimaicon {
              &:before {
                position: absolute;
                width: 20px;
                height: 22px;
                content: "";
                background: url("../../../static/images/password.png") no-repeat;
                background-size: 20px 22px;
              }
            }

            .yzmicon {
              &:before {
                position: absolute;
                width: 20px;
                height: 22px;
                content: "";
                background: url("../../../static/images/yzcode.png") no-repeat;
                background-size: 20px 22px;
              }
            }

            p {
              margin: 0;
              position: absolute;
              top: 50%;
              margin-top: -14px;

              right: 14px;
              z-index: 99;

              i {
                font-size: 26px;
                color: #a7b6c3;
              }

              .icon-yanjing {
                color: #237fcc;
              }
            }

            .ischange {
              width: 28px;
              height: 20px;
            }

            input {
              height: 0.5rem;
              width: 100%;
              color: #a7b6c3;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: none;

              font-size: 0.16rem;
              border-radius: 0.15rem;
            }

            .el-input__inner {
              border: solid 0.02rem #d2d2d2;
              padding-left: 0.4rem;
            }

            .verifyImg {
              width: 35%;
              height: 0.45rem;
              background: #fff;
              position: absolute;
              right: 0.4rem;
              top: 0;
              border-radius: 4px;
            }
          }

          .el-checkbox {
            color: #237fcc;
          }

          .checkInfo {
            margin-bottom: 36px;

            .el-checkbox__input.is-checked .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background-color: #237fcc;
            }

            .el-checkbox__input.is-checked + .el-checkbox__label {
              font-size: 14px;
              color: #237fcc;
            }
          }

          .loginBtn {
            font-family: MicrosoftYaHei;
            color: #ffff;
            width: 100%;
            outline: none;
            cursor: pointer;
            font-size: 0.2rem;
            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            height: 0.4rem;
            // background-color: #237fcc;
            border-radius: 0.4rem;
            background-image: linear-gradient(to right, #00c1ff, #00c1ff);
            border: none;
            margin-top: 0.78rem;
            font-size: 0.16rem;
          }

          .checkagreement {
            width: 5rem;
            height: 0.4rem;
            // background-color: #00c1ff;
            display: flex;
            position: absolute;
            top: 2.4rem;
            left: 0;

            .gundong::-webkit-scrollbar {
              width: 6px;
            }

            .gundong::-webkit-scrollbar-thumb {
              background: #e1e1e1;
              border-radius: 4px;
            }

            .c2 {
              // position: absolute;
              // top: 2.4rem;
              // left: 0.1rem;
              color: #fff;
              font-size: 0.16rem;
            }

            .c3 {
              // position: absolute;
              // top: 2.4rem;
              // left: 0.95rem;
              height: 0.2rem;
              color: #5dbcdb;
              font-size: 0.16rem;
              display: flex;
              flex-direction: column;
            }
            .c3::after {
              content: "";
              width: 80%;
              height: 1px;
              display: block;
              margin: 0 auto;
              border-bottom: 1px solid #5dbcdb;
            }
            .c8 {
              display: none;
            }
          }

          .registerBtnzz {
            color: #fff;

            z-index: 1000;
            font-size: 0.16rem;
          }

          .registerBtn {
            font-family: MicrosoftYaHei;
            color: #5dbbda;
            outline: none;
            cursor: pointer;
            font-size: 0.14rem;

            box-sizing: border-box;
            -webkit-box-sizing: border-box;
          }

          .el-form-item.is-success .el-input__inner,
          .el-form-item.is-success .el-input__inner:focus,
          .el-form-item.is-success .el-textarea__inner,
          .el-form-item.is-success .el-textarea__inner:focus {
            border-color: #4c94fd !important;
          }

          .el-form-item.is-error .el-input__inner,
          .el-form-item.is-error .el-input__inner:focus,
          .el-form-item.is-error .el-textarea__inner,
          .el-form-item.is-error .el-textarea__inner:focus,
          .el-message-box__input input.invalid,
          .el-message-box__input input.invalid:focus {
            border-color: #4c94fd !important;
          }

          .el-form-item.is-success label {
            color: #4c94fd;
          }

          .el-form-item.is-success .nameicon {
            &:before {
              position: absolute;
              width: 24px;
              height: 26px;
              content: "";
              background-size: 24px 26px;
            }
          }

          .el-form-item.is-success .mimaicon {
            &:before {
              position: absolute;
              width: 24px;
              height: 26px;
              content: "";
              background-size: 24px 26px;
            }
          }

          .el-form-item.is-success .yzmicon {
            &:before {
              position: absolute;
              width: 24px;
              height: 26px;
              content: "";
              background-size: 24px 26px;
            }
          }
        }
      }
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #237fcc;
      border-color: #237fcc;
    }
  }

  .btnbg {
    width: 100%;
  }
}
</style>
<style lang="css" scoped>
.box {
  width: 100%;
  position: relative;
}

.box img {
  width: 100%;
}

.box .login {
  position: absolute;
  width: 500px;
  height: 400px;
  top: 50%;
  left: 50%;
  margin-left: -250px;
  margin-top: -300px;
}

.login .login-title {
  width: 100%;
  text-align: center;
}

.login-title img {
  width: 190px;
  height: auto;
}

.login-title p {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #fff;
  letter-spacing: 0.29px;
  padding-top: 10px;
  padding-bottom: 50px;
}

.login_box {
  width: 400px;
  height: auto;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.login_box .title {
  font-size: 20px;
  color: #9b9b9b;
  letter-spacing: 0.32px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-around;
  padding: 50px 60px 0 60px;
  margin-bottom: 20px;
  cursor: pointer;
}

.login_box .title span:nth-of-type(1) {
  color: #4a4a4a;
  border-bottom: 2px solid #84cc39;
}

.inp {
  width: 350px;
  margin: 0 auto;
}

.inp input {
  border: 0;
  outline: 0;
  width: 100%;
  height: 45px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  text-indent: 20px;
  font-size: 14px;
  background: #fff !important;
}

.inp input.user {
  margin-bottom: 16px;
}

.inp .rember {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 10px;
}

.inp .rember p:first-of-type {
  font-size: 12px;
  color: #4a4a4a;
  letter-spacing: 0.19px;
  margin-left: 22px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  /*position: relative;*/
}

.inp .rember p:nth-of-type(2) {
  font-size: 14px;
  color: #9b9b9b;
  letter-spacing: 0.19px;
  cursor: pointer;
}

.inp .rember input {
  outline: 0;
  width: 30px;
  height: 45px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  text-indent: 20px;
  font-size: 14px;
  background: #fff !important;
}

.inp .rember p span {
  display: inline-block;
  font-size: 12px;
  width: 100px;
  /*position: absolute;*/
  /*left: 20px;*/
}

#geetest {
  margin-top: 20px;
}

.login_btn {
  width: 100%;
  height: 45px;
  background: #0980cc;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
  letter-spacing: 0.26px;
  margin-top: 30px;
}

.inp .go_login {
  text-align: center;
  font-size: 14px;
  color: #9b9b9b;
  letter-spacing: 0.26px;
  padding-top: 20px;
}

.inp .go_login span {
  color: #84cc39;
  cursor: pointer;
}

.headers1 {
  height: 50px;
  background: #fff;
  position: absolute;
  z-index: 11;
  top: 0;
  width: 100%;
}

.headers1 img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  height: 30px;
}

.headers2 {
  /* height:50px; */
  /* background: #fff; */
  position: relative;
  z-index: 11;
  top: 0;
  width: 100%;
}

.headers2 img {
  position: absolute;
  top: 10px;

  left: 24px;
  height: 80px;
}
</style>
<style>
.loginContainer {
  width: 100%;
  height: 100%;
  background: #fff;
}

.loginInner {
  width: 80%;
  margin: 0 auto;
  padding-top: 5px;
}

.loginInner .login_header .login_logo {
  color: #02a774;
  font-weight: bolder;
  font-size: 40px;
  text-align: center;
}

.login_header .login_header_title {
  text-align: center;
  padding-top: 5px;
}

.login_header_title a {
  text-decoration: none;
  font-size: 14px;
  color: #333;
  padding-bottom: 4px;
}

.login_header_title a:first-child {
  margin-right: 40px;
}

.login_header_title a.on {
  color: #02a774;
  font-weight: bolder;
  border-bottom: 2px solid #02a774;
}

.login_content form div {
  display: none;
}

.login_content form div.on {
  display: block;
}

.login_content form input {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
  padding-left: 10px;
  box-sizing: border-box;
}

.login_content form input:focus {
  border: 1px solid #02a774;
}

.login_message {
  position: relative;
  margin-top: 16px;
  height: 48px;
  font-size: 14px;
  background: #fff;
}

.login_message .get_verification {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border: none;
  color: #ccc;
  background: transparent;
  font-size: 14px;
}

.login_message .get_verification.right_phone {
  color: #000;
}

.login_hint {
  color: #999;
  margin-top: 12px;
  font-size: 14px;
  line-height: 20px;
}

.login_hint a {
  text-decoration: none;
  color: #02a774;
}

.login_verification {
  position: relative;
  margin-top: 16px;
  height: 48px;
  font-size: 14px;
  background: #fff;
}

.login_verification .switch_button {
  border: 1px solid #ddd;
  width: 30px;
  height: 16px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border-radius: 8px;
  padding: 0 6px;
  line-height: 16px;
  font-size: 12px;
  transition: background-color 0.3s;
}

.login_verification .switch_button.on {
  background: #02a774;
}

.login_verification .switch_button.off {
  background: #fff;
}

.switch_button .switch_circle {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  position: absolute;
  left: -1px;
  top: -1px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
}

.switch_button .switch_circle.right {
  transform: translateX(30px);
}

.switch_button .switch_text {
  color: #ddd;
  float: right;
}

.login_submit {
  width: 50%;
  height: 42px;
  margin-top: 30px;
  background: #4cd96f;
  border-radius: 4px;
  font-size: 16px;
  line-height: 42px;
  color: #fff;
  text-align: center;
  border: none;
}

.ruleForm {
  width: 360px;
}

.ruleForm .el-select .el-input {
  width: 260px;
}

.ruleForm.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 260px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue